<template>
  <el-dialog
    title="选择商品"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.goodsName"
        placeholder="请输入商品名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.exchangeGoodsId"
            :label="row.exchangeGoodsId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="goodsName"></el-table-column>
      <el-table-column
        label="商品描述"
        prop="goodsDesc"></el-table-column>
      <el-table-column
        label="库存量"
        width="90"
        prop="storageCount"></el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'GoodsSelectModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        goodsName: ''
      },
      total: 0,
      current: {}
    }
  },
  watch: {
    current: {
      handler(val) {
        console.log(val)
      },
      deep: true
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.exchangeGoodsId) {
        this.$message.error('请选择一个商品')
        return
      }
      this.callback && this.callback(this.current)
      this.toggleModal(false)
    },
    handleCurrentRowChange(row) {
      console.log('handleCurrentRowChange', row)
      if (row && row.isOngoingSeckillGoods === 1) {
        this.$message.error('该商品已在特惠活动中')
        return
      }
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('goods/getgoodslist', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
